import React from 'react';
import styled from 'styled-components';

import { capitalise } from '../helpers';

import ExpandableCopy from './ExpandableCopy';
import VendorProfileSection from './VendorProfileSection';

const stars = (num = 1) => {
  const arr = new Array(num);
  return arr.fill('★').join('');
};

const ReviewWrapper = styled.div`
  border-bottom: solid 1px #e9e9e9;
  padding-bottom: 24px;
  margin-bottom: 24px;
`;

const Stars = styled.span`
  color: #f9a41e;
  padding-right: 12px;
`;

const ReviewMeta = styled.div`
  color: #9e9e9e;
  font-size: 14px;
  padding-bottom: 16px;
`;

const Body = styled.div`
  color: #777;
  font-size: 16px;
`;

const Review = ({ review }) => {
  const { body, reviewer_name, platform, rating, timestamp, url } = review;
  return (
    <ReviewWrapper>
      <ReviewMeta>
        <Stars>{stars(rating)}</Stars> Reviewed by {reviewer_name} on{' '}
        {capitalise(platform)}
      </ReviewMeta>
      <Body>
        <ExpandableCopy ignore={body.length < 150}>{body}</ExpandableCopy>
      </Body>
    </ReviewWrapper>
  );
};

export default function Reviews({ reviews = [] }) {
  return (
    <VendorProfileSection title="Reviews">
      <div>
        {reviews.map((review, index) => {
          return <Review review={review} key={index} />;
        })}
      </div>
    </VendorProfileSection>
  );
}
